/* Prowwl product page (PDP V1): gallery, review quotes, size, purchase option, add to cart. */
(function () {
  'use strict';

  /* Format cents like the store does, using a sample the theme rendered ("$1,000.00", "1.000,00 €"…). */
  function moneyFormatter(sample) {
    var match = /1([^0-9]?)000(?:([^0-9])00)?/.exec(sample || '');
    if (!match) {
      return function (cents) { return '$' + (cents / 100).toFixed(2); };
    }
    var thousands = match[1] || '';
    var decimal = match[2] || '';
    var before = sample.slice(0, match.index);
    var after = sample.slice(match.index + match[0].length);
    return function (cents) {
      var value = Math.round(cents);
      var whole = Math.floor(value / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      var fraction = decimal ? decimal + ('0' + (value % 100)).slice(-2) : '';
      return before + whole + fraction + after;
    };
  }

  /* Sticky left column: stick below the header, but never hide the bottom of a column
     that is taller than the screen (then it sticks to the bottom instead). */
  function initStickyLeft(root) {
    var left = root.querySelector('[data-pw-left]');
    if (!left) return;
    function update() {
      var top = 90;
      var room = window.innerHeight - left.offsetHeight - 24;
      left.style.setProperty('--pw-left-top', Math.min(top, room) + 'px');
    }
    update();
    window.addEventListener('resize', update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(left);
  }

  /* "Pairs well with": arrows scroll one card at a time and fade at the ends. */
  function initPairs(root) {
    var row = root.querySelector('[data-pw-pairs-row]');
    var prev = root.querySelector('[data-pw-pairs-prev]');
    var next = root.querySelector('[data-pw-pairs-next]');
    if (!row || !prev || !next) return;
    function step() {
      var card = row.firstElementChild;
      return card ? card.getBoundingClientRect().width + 10 : row.clientWidth * 0.8;
    }
    function update() {
      prev.disabled = row.scrollLeft <= 8;
      next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 8;
    }
    prev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
    row.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initGallery(root) {
    var track = root.querySelector('[data-pw-gallery-track]');
    var thumbs = root.querySelectorAll('[data-pw-thumb]');
    if (!track || !thumbs.length) return;
    var slides = track.querySelectorAll('[data-pw-slide]');

    function setActive(index) {
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', Number(thumb.getAttribute('data-pw-thumb')) === index);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = Number(thumb.getAttribute('data-pw-thumb'));
        var slide = slides[index];
        if (!slide) return;
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        setActive(index);
      });
    });

    /* Chevrons: step one image at a time; fade out at the ends. */
    var prev = root.querySelector('[data-pw-gallery-prev]');
    var next = root.querySelector('[data-pw-gallery-next]');
    function current() { return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); }
    function goTo(index) {
      var slide = slides[Math.max(0, Math.min(slides.length - 1, index))];
      if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function updateArrows() {
      var i = current();
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    }
    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    updateArrows();
    track.addEventListener('scroll', updateArrows, { passive: true });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        setActive(index);
        slides.forEach(function (slide, i) {
          if (i === index) return;
          var video = slide.querySelector('video');
          if (video && !video.paused) video.pause();
        });
      });
    }, { passive: true });
  }

  function initQuotes(root) {
    var box = root.querySelector('[data-pw-quotes]');
    if (!box) return;
    var quotes = box.querySelectorAll('[data-pw-quote]');
    var dots = box.querySelectorAll('[data-pw-quote-dot]');
    if (quotes.length < 2) return;
    var current = 0;

    function show(index) {
      current = (index + quotes.length) % quotes.length;
      quotes.forEach(function (quote, i) { quote.hidden = i !== current; });
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === current); });
    }

    var prev = box.querySelector('[data-pw-quote-prev]');
    var next = box.querySelector('[data-pw-quote-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
  }

  function updateCartCounts(cart) {
    if (!cart) return;
    document.querySelectorAll(
      '.cart-count-bubble, .cart-count, [data-cart-count], [data-header-cart-count], .prowwl-header__cart-count'
    ).forEach(function (node) {
      node.textContent = cart.item_count;
      node.classList.toggle('hidden', cart.item_count === 0);
      node.classList.toggle('is-empty', cart.item_count === 0);
    });
  }

  /* Tell the theme's cart (drawer contents, cart bubble) that the cart changed. */
  function refreshThemeCart(cartJsUrl) {
    return fetch(cartJsUrl, { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        updateCartCounts(cart);
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart || undefined,
            sourceId: 'prowwl-pdp-main',
            data: { source: 'prowwl-pdp-main', itemCount: cart ? cart.item_count : undefined }
          }
        }));
      })
      .catch(function () {});
  }

  /* Wait until the drawer has re-rendered (1.5s at most), so it never opens on old contents. */
  function whenCartDrawerUpdated(callback) {
    var cartItems = document.querySelector('cart-drawer-component cart-items-component');
    if (!cartItems || !('MutationObserver' in window)) {
      callback();
      return;
    }
    var finished = false;
    var observer = new MutationObserver(finish);
    var timer = setTimeout(finish, 1500);
    function finish() {
      if (finished) return;
      finished = true;
      observer.disconnect();
      clearTimeout(timer);
      callback();
    }
    observer.observe(cartItems.closest('.shopify-section') || cartItems, { childList: true, subtree: true });
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component, cart-drawer, #CartDrawer, #cart-drawer, [data-cart-drawer]');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    var trigger = document.querySelector('[data-cart-drawer-open], [data-open-cart], [aria-controls="CartDrawer"], [aria-controls="cart-drawer"]');
    if (trigger) {
      trigger.click();
      return true;
    }
    return false;
  }

  /* fetch from a blank same-origin frame, which no app script has wrapped. */
  var cleanFetchFn = null;
  function cleanFetch() {
    if (cleanFetchFn) return cleanFetchFn;
    try {
      var frame = document.createElement('iframe');
      frame.hidden = true;
      frame.setAttribute('aria-hidden', 'true');
      frame.tabIndex = -1;
      document.body.appendChild(frame);
      if (frame.contentWindow && frame.contentWindow.fetch) {
        cleanFetchFn = frame.contentWindow.fetch.bind(frame.contentWindow);
        return cleanFetchFn;
      }
    } catch (e) {}
    return window.fetch.bind(window);
  }

  function initBuyBox(root) {
    var dataEl = root.querySelector('[data-pw-product-json]');
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!dataEl || !form) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var money = moneyFormatter(data.moneySample);
    var labels = data.labels || {};
    var variants = {};
    data.variants.forEach(function (variant) { variants[variant.id] = variant; });

    var state = { variantId: data.currentVariant, plan: '', lastPlan: '', qty: 1 };

    var el = {
      variantInput: form.querySelector('[data-pw-variant-input]'),
      planInput: form.querySelector('[data-pw-plan-input]'),
      qty: form.querySelector('[data-pw-qty]'),
      /* Lists, because the pre-order app shows a copy of the button. */
      add: form.querySelectorAll('[data-pw-add]'),
      addLabel: form.querySelectorAll('[data-pw-add-label]'),
      addPrice: form.querySelectorAll('[data-pw-add-price]'),
      error: root.querySelector('[data-pw-error]'),
      priceNow: root.querySelector('[data-pw-price-now]'),
      priceWas: root.querySelector('[data-pw-price-was]'),
      priceSave: root.querySelector('[data-pw-price-save]'),
      unit: root.querySelector('[data-pw-unit]'),
      oncePrice: root.querySelector('[data-pw-once-price]'),
      subPrice: root.querySelector('[data-pw-sub-price]'),
      subWas: root.querySelector('[data-pw-sub-was]'),
      subTitle: root.querySelector('[data-pw-sub-title]'),
      sizeLabel: root.querySelector('[data-pw-size-label]'),
      options: root.querySelectorAll('[data-pw-opt]'),
      radios: root.querySelectorAll('[data-pw-plan-radio]'),
      chips: root.querySelectorAll('[data-pw-plan]'),
      sizeButtons: root.querySelectorAll('[data-pw-variant]')
    };

    /* Plans in the order of the frequency chips (Bi-Weekly first), so the first chip is the default. */
    var chipOrder = Array.prototype.map.call(el.chips, function (c) { return c.getAttribute('data-pw-plan'); });
    function planIds(variant) {
      var ids = Object.keys(variant.plans || {});
      return chipOrder.filter(function (id) { return ids.indexOf(id) !== -1; })
        .concat(ids.filter(function (id) { return chipOrder.indexOf(id) === -1; }));
    }
    function pct(variant, planId) {
      var price = variant.plans[planId];
      if (price == null || !variant.price) return 0;
      return Math.round((1 - price / variant.price) * 100);
    }
    /* Price and percent from the 2nd delivery on. Same as the first unless the plan has a first-order discount. */
    function later(variant, planId) {
      var l = variant.later && variant.later[planId];
      return l != null ? l : variant.plans[planId];
    }
    function laterPct(variant, planId) {
      var price = later(variant, planId);
      if (price == null || !variant.price) return 0;
      return Math.round((1 - price / variant.price) * 100);
    }
    function hasIntro(variant, planId) { return planId && later(variant, planId) > variant.plans[planId]; }
    function fill(text, variant, planId) {
      return (text || '').replace(/\[first\]/g, planId ? pct(variant, planId) : '').replace(/\[percent\]/g, planId ? laterPct(variant, planId) : '');
    }

    /* Percent on each frequency chip. */
    function renderChips(variant) {
      el.chips.forEach(function (chip) {
        var id = chip.getAttribute('data-pw-plan');
        var pctEl = chip.querySelector('[data-pw-plan-pct]');
        var p = laterPct(variant, id);
        if (pctEl) pctEl.textContent = p > 0 ? ' · save ' + p + '%' : '';
        chip.classList.toggle('is-active', id === (state.plan || state.lastPlan));
        chip.setAttribute('aria-pressed', id === state.plan ? 'true' : 'false');
        chip.hidden = !(id in (variant.plans || {}));
      });
    }

    function render() {
      var variant = variants[state.variantId];
      if (!variant) return;
      var ids = planIds(variant);
      if (!state.lastPlan || ids.indexOf(state.lastPlan) === -1) state.lastPlan = ids[0] || '';
      if (state.plan && ids.indexOf(state.plan) === -1) state.plan = '';

      var once = variant.price;
      var shownPlan = state.plan || state.lastPlan;
      var sub = shownPlan ? variant.plans[shownPlan] : null;
      var now = state.plan ? sub : once;

      if (el.priceNow) el.priceNow.textContent = money(now);
      if (el.unit) {
        var oz = variant.oz > 0 ? variant.oz : parseFloat(el.unit.getAttribute('data-pw-unit-oz'));
        if (oz > 0) el.unit.textContent = money(Math.round(now / oz));
      }
      var was = 0;
      var saveText = '';
      if (state.plan && now < once) {
        was = once;
        saveText = (labels.saveSub || '').replace('[amount]', money(once - now));
      } else if (variant.compare > now) {
        was = variant.compare;
        saveText = (labels.saveCompare || '').replace('[amount]', money(variant.compare - now));
      }
      if (el.priceWas) { el.priceWas.hidden = !was; el.priceWas.textContent = was ? money(was) : ''; }
      if (el.priceSave) { el.priceSave.hidden = !saveText; el.priceSave.textContent = saveText; }

      if (el.oncePrice) el.oncePrice.textContent = money(once);
      if (el.subPrice) el.subPrice.textContent = sub != null ? money(sub) : '';
      if (el.subWas) el.subWas.textContent = money(once);
      var intro = hasIntro(variant, shownPlan);
      if (el.subTitle) el.subTitle.textContent = fill(intro && labels.subTitleIntro ? labels.subTitleIntro : labels.subTitle, variant, shownPlan);
      renderChips(variant);

      /* Subscription ticks: "[percent]" follows the selected plan. With a first-order discount, the
         tick that mentions [percent] becomes "30% off your first order, then 20% on every delivery". */
      root.querySelectorAll('[data-pw-tick]').forEach(function (tick) {
        var raw = tick.getAttribute('data-pw-tick');
        if (intro && labels.subTickIntro && raw.indexOf('[percent]') !== -1) raw = labels.subTickIntro;
        tick.textContent = fill(raw, variant, shownPlan);
      });

      /* "Your plan: 1 bag (3oz) every 2 weeks · $7.99 per delivery" */
      var summary = root.querySelector('[data-pw-plan-summary]');
      if (summary) {
        var size = variant.size || summary.getAttribute('data-pw-size');
        var bags = state.qty + (state.qty === 1 ? ' bag' : ' bags') + (size ? ' (' + size + ')' : '');
        var line;
        if (state.plan) {
          var chip = root.querySelector('[data-pw-plan="' + state.plan + '"]');
          var interval = chip ? chip.getAttribute('data-pw-plan-interval') : '';
          line = bags + (interval ? ' ' + interval : '') + ' · ' + (hasIntro(variant, state.plan)
            ? money(now * state.qty) + ' first order, then ' + money(later(variant, state.plan) * state.qty) + ' per delivery'
            : money(now * state.qty) + ' per delivery');
        } else {
          line = bags + ', one-time · ' + money(now * state.qty);
        }
        summary.innerHTML = '';
        var strong = document.createElement('strong');
        strong.textContent = (summary.getAttribute('data-pw-label') || 'Your plan') + ': ';
        summary.appendChild(strong);
        summary.appendChild(document.createTextNode(line));
      }

      el.options.forEach(function (option) {
        var isSub = option.getAttribute('data-pw-opt') === 'sub';
        option.classList.toggle('is-active', isSub === !!state.plan);
      });
      el.radios.forEach(function (radio) { radio.checked = (radio.value === 'sub') === !!state.plan; });

      if (el.variantInput) el.variantInput.value = variant.id;
      if (el.planInput) {
        el.planInput.value = state.plan || '';
        el.planInput.disabled = !state.plan;
      }

      var label = !variant.available ? labels.soldOut : (variant.preorder && labels.preorder ? labels.preorder : labels.add);
      /* Query again: the pre-order app copies the button after this script starts. */
      form.querySelectorAll('[data-pw-add-label]').forEach(function (node) { node.textContent = label; });
      form.querySelectorAll('[data-pw-add-price]').forEach(function (node) {
        node.textContent = variant.available ? ' · ' + money(now * state.qty) : '';
      });
      form.querySelectorAll('[data-pw-add]').forEach(function (button) { button.disabled = !variant.available; });

      /* Sticky bar mirrors the buy box. */
      var sticky = root.__pwSticky || root.querySelector('[data-pw-sticky]');
      if (sticky) {
        var sLabel = sticky.querySelector('[data-pw-sticky-label]');
        var sPrice = sticky.querySelector('[data-pw-sticky-price]');
        var sSub = sticky.querySelector('[data-pw-sticky-sub]');
        var sBtn = sticky.querySelector('[data-pw-sticky-add]');
        if (sLabel) sLabel.textContent = label;
        if (sPrice) sPrice.textContent = variant.available ? ' · ' + money(now * state.qty) : '';
        if (sBtn) sBtn.disabled = !variant.available;
        if (sSub) {
          var bits = [];
          if (variant.size || labels.size) bits.push(variant.size || labels.size);
          if (state.plan) {
            var sChip = root.querySelector('[data-pw-plan="' + state.plan + '"]');
            bits.push('Subscribe · ' + (sChip ? sChip.getAttribute('data-pw-plan-interval') : ''));
          } else {
            bits.push(labels.once || 'One-time');
          }
          sSub.textContent = bits.join(' · ');
        }
      }
      if (el.sizeLabel) el.sizeLabel.textContent = variant.title;
      root.querySelectorAll('[data-pw-size-text]').forEach(function (node) { if (variant.size) node.textContent = variant.size; });
      el.sizeButtons.forEach(function (button) {
        var active = Number(button.getAttribute('data-pw-variant')) === variant.id;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    el.radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        state.plan = radio.value === 'sub' ? state.lastPlan : '';
        render();
      });
    });

    el.chips.forEach(function (chip) {
      chip.addEventListener('click', function (event) {
        event.preventDefault();
        state.lastPlan = chip.getAttribute('data-pw-plan');
        state.plan = state.lastPlan;
        render();
      });
    });

    el.sizeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        state.variantId = Number(button.getAttribute('data-pw-variant'));
        var url = new URL(window.location.href);
        url.searchParams.set('variant', state.variantId);
        window.history.replaceState({}, '', url.toString());
        render();
        /* Show the selected size's bag photo. */
        var picked = variants[state.variantId];
        var track = root.querySelector('[data-pw-gallery-track]');
        var slide = track && picked && picked.media >= 0 ? track.querySelectorAll('[data-pw-slide]')[picked.media] : null;
        if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    });

    function setQty(value) {
      state.qty = Math.max(1, parseInt(value, 10) || 1);
      if (el.qty) el.qty.value = state.qty;
      render();
    }
    if (el.qty) {
      el.qty.addEventListener('change', function () { setQty(el.qty.value); });
      var minus = form.querySelector('[data-pw-qty-minus]');
      var plus = form.querySelector('[data-pw-qty-plus]');
      if (minus) minus.addEventListener('click', function () { setQty(state.qty - 1); });
      if (plus) plus.addEventListener('click', function () { setQty(state.qty + 1); });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (el.error) { el.error.hidden = true; el.error.textContent = ''; }
      form.querySelectorAll('[data-pw-add]').forEach(function (button) { button.setAttribute('aria-busy', 'true'); });

      var body = new FormData(form);
      body.set('id', state.variantId);
      body.set('quantity', state.qty);
      var send = window.fetch.bind(window);
      if (state.plan) {
        /* An app on the store rewrites add-to-cart requests and drops the subscription plan,
           so subscriptions go through an untouched fetch. One-time purchases keep the apps'
           handling (the pre-order app adds its plan and notes there). */
        body.delete('selling_plan_radio');
        body.set('selling_plan', state.plan);
        send = cleanFetch();
      }

      send(new URL(data.cartAddUrl, window.location.origin).toString(), { method: 'POST', body: body, headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.json().then(function (json) {
            if (!response.ok) throw json;
            return json;
          });
        })
        .then(function () {
          var refreshed = refreshThemeCart(data.cartJsUrl);
          if (!data.openDrawer) return;
          refreshed.then(function () {
            whenCartDrawerUpdated(function () {
              if (!openCartDrawer()) window.location.href = data.cartUrl;
            });
          });
        })
        .catch(function (error) {
          if (!el.error) return;
          el.error.hidden = false;
          el.error.textContent = (error && (error.description || error.message)) || labels.error;
        })
        .finally(function () {
          form.querySelectorAll('[data-pw-add]').forEach(function (button) { button.removeAttribute('aria-busy'); });
        });
    });

    var plansBox = root.querySelector('[data-pw-default-plan]');
    if (plansBox && plansBox.getAttribute('data-pw-default-plan') === 'sub') {
      var firstVariant = variants[state.variantId];
      var firstPlans = firstVariant ? planIds(firstVariant) : [];
      if (firstPlans.length) { state.plan = firstPlans[0]; state.lastPlan = firstPlans[0]; }
    }

    initSticky(root, form);
    render();
  }

  /* Sticky add-to-cart: shows once the real button has scrolled above the viewport. */
  function initSticky(root, form) {
    var sticky = root.querySelector('[data-pw-sticky]');
    var buy = root.querySelector('.pw-pdp-main__buy');
    if (!sticky || !buy) return;
    document.body.appendChild(sticky);
    root.__pwSticky = sticky;
    var btn = sticky.querySelector('[data-pw-sticky-add]');
    function setVisible(on) {
      sticky.classList.toggle('is-visible', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (btn) btn.tabIndex = on ? 0 : -1;
      document.documentElement.classList.toggle('pw-pdp-has-sticky', on);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }).observe(buy);
    }
    if (btn) {
      btn.addEventListener('click', function () {
        var visible = Array.prototype.find.call(form.querySelectorAll('[data-pw-add]'), function (b) {
          return b.getBoundingClientRect().width > 0;
        });
        if (visible) visible.click();
        else if (form.requestSubmit) form.requestSubmit();
      });
    }
  }

  /* Small "added" feedback for buttons that don't open the drawer: the product photo flies to the cart icon, which bounces. */
  function flyToCart(button) {
    var icon = Array.prototype.find.call(document.querySelectorAll('cart-icon, .header-actions__cart-icon'), function (el) {
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight;
    });
    function bump() {
      if (!icon) return;
      icon.classList.remove('pw-cart-bump');
      void icon.offsetWidth;
      icon.classList.add('pw-cart-bump');
      setTimeout(function () { icon.classList.remove('pw-cart-bump'); }, 600);
    }
    var card = button.closest('.pw-pdp-pair, .pw-pdp-card');
    var img = card && card.querySelector('img');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!icon || !img || reduce) { bump(); return; }
    var from = img.getBoundingClientRect();
    var to = icon.getBoundingClientRect();
    var size = Math.min(from.width, from.height, 64);
    var ghost = img.cloneNode(false);
    ghost.removeAttribute('srcset');
    ghost.src = img.currentSrc || img.src;
    ghost.alt = '';
    ghost.className = 'pw-fly';
    ghost.style.cssText = 'left:' + (from.left + from.width / 2 - size / 2) + 'px;top:' + (from.top + from.height / 2 - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px;';
    document.body.appendChild(ghost);
    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height / 2 - (from.top + from.height / 2);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        ghost.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.25)';
        ghost.style.opacity = '0.4';
      });
    });
    var done = false;
    function finish() { if (done) return; done = true; ghost.remove(); bump(); }
    ghost.addEventListener('transitionend', finish, { once: true });
    setTimeout(finish, 900);
  }

  /* One-tap add for other products (Pairs well with, other flavor cards). */
  function initQuickAdd() {
    if (document.__pwQuickAdd) return;
    document.__pwQuickAdd = true;
    var dataEl = document.querySelector('[data-pw-product-json]');
    var data = {};
    try { data = dataEl ? JSON.parse(dataEl.textContent) : {}; } catch (e) {}
    var labels = data.labels || {};
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-pw-quick-add]');
      if (!button) return;
      event.preventDefault();
      var original = button.innerHTML;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      var item = { id: Number(button.getAttribute('data-pw-quick-add')), quantity: 1 };
      var plan = button.getAttribute('data-pw-plan');
      if (plan) item.selling_plan = Number(plan);
      // Subscriptions skip the app that drops selling plans from add-to-cart requests (see initBuyBox).
      var send = plan ? cleanFetch() : window.fetch.bind(window);
      send(new URL(data.cartAddUrl || '/cart/add.js', window.location.origin).toString(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (response) { if (!response.ok) throw new Error('add failed'); return response.json(); })
        .then(function () {
          button.dispatchEvent(new CustomEvent('pw:quick-added', { bubbles: true }));
          button.classList.add('is-added');
          button.textContent = labels.added || 'Added';
          var refreshed = refreshThemeCart(data.cartJsUrl || '/cart.js');
          // "Pairs well with" stays on the page: animate to the cart icon instead of opening the drawer.
          if (button.hasAttribute('data-pw-no-drawer')) flyToCart(button);
          else if (data.openDrawer) refreshed.then(function () { whenCartDrawerUpdated(function () { openCartDrawer(); }); });
          setTimeout(function () { button.classList.remove('is-added'); button.innerHTML = original; }, 2200);
        })
        .catch(function () {
          button.innerHTML = original;
          button.dispatchEvent(new CustomEvent('pw:quick-add-failed', { bubbles: true }));
        })
        .finally(function () { button.disabled = false; button.removeAttribute('aria-busy'); });
    });
  }

  function init(root) {
    if (root.__pwPdpReady) return;
    root.__pwPdpReady = true;
    initGallery(root);
    initStickyLeft(root);
    initPairs(root);
    initQuotes(root);
    initBuyBox(root);
  }

  function initAll() {
    document.querySelectorAll('[data-pw-pdp-main]').forEach(init);
    initQuickAdd();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
